// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ot-0";